import { render } from "./control-user-location.vue?vue&type=template&id=aa40dac6&scoped=true"
import script from "./control-user-location.vue?vue&type=script&lang=js"
export * from "./control-user-location.vue?vue&type=script&lang=js"

import "./control-user-location.vue?vue&type=style&index=0&id=aa40dac6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa40dac6"]])

export default __exports__